export default __webpack_public_path__ + "static/media/mari_m.359afce3.jpg";